import React, { useEffect } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, EffectFade } from 'swiper';

import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/effect-fade/effect-fade.scss';

import './_popupWithSlider.scss';

SwiperCore.use([Navigation, EffectFade]);

export function showPopup (parentClass) {
  const classname = `${parentClass ? `${parentClass} #popupContainer` : '#popupContainer'}`;
  const popupElement = document.querySelector(classname);
  popupElement && popupElement.classList.add('show');
  const popupBody = popupElement.querySelector('#popupBlock');
  popupBody.scrollTop = 0;
  // document.body.style.overflow = 'hidden';
}

function PopupWithSlider ({ parentClass, data, setSwiper }) {
  // function slideTo(swiper) {
  //     swiper.slideTo(1, 0, false)
  // }
  const swiperParams = {
    speed: 1000,
    spaceBetween: 70,
    slidesPerView: 1,
    autoHeight: true,
  };

  function createVideoUrl (url) {
    const vimeo_Reg = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
    const watchY = url.match(/(\?|&)v=([^&#]+)/);
    const embedY = url.match(/(\.be\/)+([^/]+)/);
    const beY = url.match(/(embed\/)+([^/]+)/);
    const vimeoURL = url.match(vimeo_Reg);
    const videoURL = url.match(/https:\/\/(:?www.)?(\w*)/)[2];
    if (videoURL.includes('youtu')) {
      if (watchY) {
        return 'https://www.youtube.com/embed/' + watchY.pop();
      } else if (embedY) {
        return 'https://www.youtube.com/embed/' + embedY.pop();
      } else if (beY) {
        return 'https://www.youtube.com/embed/' + beY.pop();
      }
    } else if (videoURL.includes('vimeo') || videoURL.includes('player')) {
      if (vimeoURL) {
        return 'https://player.vimeo.com/video/' + vimeoURL[3];
      }
    }
  }

  function closePopup () {
    const iFrame = document.querySelector('#responsive-iframe');
    iFrame && iFrame.setAttribute('src', iFrame.getAttribute('src'));
    document.querySelector(`${parentClass || ''} #popupContainer`).classList.remove('show');
    // document.body.style.overflow = 'auto';
  }

  function hidePopupWithEsc (e) {
    e.keyCode === 27 && closePopup();
  }

  useEffect(() => {
    window.addEventListener('keyup', hidePopupWithEsc);
    return () => window.removeEventListener('keyup', hidePopupWithEsc);
  }, []);
  return (
        <div className='popupContainer' id='popupContainer'>
            <div className='closeDiv' onClick={closePopup}/>
            <div className='my-swiper-button-prev my-swiper-button'>
                <img src='/media/icons/inclassica/icon-prev.svg' alt='previous icon'/>
            </div>
            <div className='popupBlock whiteBg' id='popupBlock'>
                <div className='closeIcon' onClick={closePopup}/>
                <div className='press-inner-popup-swiper'>
                    <Swiper {...swiperParams}
                            navigation={{
                                nextEl: '.my-swiper-button-next',
                                prevEl: '.my-swiper-button-prev',
                            }}
                            onInit={setSwiper}
                            // effect="fade"
                    >
                        {data.map((el, i) => {
                            return (
                                <SwiperSlide key={i}>
                                    <div className='sliderItem'>
                                        <div>
                                            <h5 className='press-inner-popup-title'>{el.title}</h5>
                                            <div dangerouslySetInnerHTML={{ __html: el.description }} className='press-inner-popup-desc'/>
                                            {/* <p className="press-inner-popup-desc">{el.desc}</p> */}
                                            {/* <div className="press-inner-popup-artists"> */}
                                                {/* <p>ARTISTS: </p> */}
                                                {/* <ul> */}
                                                    {/* {el.artists.map((itm, idx) => { */}
                                                        {/* return ( */}
                                                            {/* <li key={idx}> */}
                                                                {/* {itm} <span>, </span> */}
                                                            {/* </li> */}
                                                        {/* ) */}
                                                    {/* })} */}
                                                {/* </ul> */}
                                            {/* </div> */}
                                        </div>
                                        {el.type === 'image' && (
                                            <div>
                                                <img className='press-inner-popup-img' src={el.image} alt='download icon'/>
                                                <a href={el.image} download className='press-inner-popup-img-link'>
                                                    <span>DOWNLOAD</span>
                                                </a>
                                            </div>
                                        )}
                                        {el.type === 'video' && (
                                            <div className='press-inner-popup-video'>
                                                <iframe title='Video' src={createVideoUrl(el.url)}/>
                                            </div>
                                        )}
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            </div>
            <div className='my-swiper-button-next my-swiper-button'>
                <img src='/media/icons/inclassica/icon-next.svg' alt='next icon'/>
            </div>
        </div>
  );
}

export default PopupWithSlider;
